import gql from 'graphql-tag'
import { /*resourceFragment,*/ resourceTypeFragment, staffVehiculeFragment } from '@/graphql/resource/resourceFragments'
import { absenceFragment, absenceTypeFragment } from '@/graphql/absence/absenceFragments'

export const userProfileFragment = gql`
    fragment userProfileFragment on UserProfile{
        id
        externalID
        is_active
        name
        first_name
        last_name
        label
        email
        secondary_email
        title
        phone_work
        phone_home
        phone_mobile
        url1
        url2
        street
        town
        state
        country
        zipcode
        is_owner
        role
        company_id
        distance
        distance_orientation
        hiring_date
        internal_notes
        ignore_tracking
        must_change_password
        deleted_at
        is_synced
        synced_at
        sync_external_id
        absences{
            ...absenceFragment
            type {
                ...absenceTypeFragment
            }
        }

        vehicule_available
        vehicules{
            ...staffVehiculeFragment
            type{
                ...resourceTypeFragment
            }
        }
    }
    ${staffVehiculeFragment}
    ${resourceTypeFragment}
    ${absenceFragment}
    ${absenceTypeFragment}
`
export const userProfileShortFragment = gql`
    fragment userProfileShortFragment on UserProfile{
        id
        is_active
        name
        first_name
        last_name
        email
        secondary_email
    }
`
export const bestCandidateFragment = gql`
    fragment bestCandidateFragment on UserProfile{
        id
        is_active
        name
        first_name
        last_name
        label
        email
        secondary_email

        relevancy
        rating
        profession
        profession_shortname
        distance
        distance_orientation
        hiring_date

        vehicule_available
        vehicules{
            ...staffVehiculeFragment
            type{
                ...resourceTypeFragment
            }
        }
    }
    ${staffVehiculeFragment}
    ${resourceTypeFragment}
`